<script setup>
import { computed } from 'vue';

const props = defineProps({
  reactions: { type: Array, required: true },
});

const emojis = computed(() => [
  ...new Set(props.reactions.map(reaction => reaction.emoji)),
]);

const tooltip = computed(() =>
  props.reactions
    .map(reaction => `${reaction.emoji} ${reaction.senderName}`.trim())
    .join('\n')
);
</script>

<template>
  <div
    v-tooltip.top="tooltip"
    class="flex items-center gap-1 px-1.5 py-0.5 text-sm leading-none rounded-full shadow-sm bg-n-solid-2 outline outline-1 outline-n-weak"
  >
    <span v-for="emoji in emojis" :key="emoji">{{ emoji }}</span>
    <span v-if="reactions.length > 1" class="text-xs text-n-slate-11">
      {{ reactions.length }}
    </span>
  </div>
</template>
